import { render, staticRenderFns } from "./Kardex-dif.vue?vue&type=template&id=4048046c&scoped=true"
import script from "./Kardex-dif.js?vue&type=script&lang=js&external"
export * from "./Kardex-dif.js?vue&type=script&lang=js&external"
import style0 from "./Kardex-dif.vue?vue&type=style&index=0&id=4048046c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048046c",
  null
  
)

export default component.exports